import { getAllCurrencyList } from "@/services/Home.service";
import { useQuery } from "@tanstack/react-query";
import { createContext, useContext, useReducer } from "react";
import { AuthReducer, initialState } from "./reducer";
import { LOGOUT } from "./types";

const AuthStateContext = createContext(null);
const AuthDispatchContext = createContext(null);

function AuthProvider(props) {
  const [state, dispatch] = useReducer(AuthReducer, initialState);

  const useCurrencies = () =>
    useQuery({
      queryKey: ["currencies"],
      queryFn: async () => await getAllCurrencyList(),
      refetchOnMount: "always",
    });

  const handleLogout = () => {
    localStorage.clear();
    dispatch({ type: LOGOUT });
  };

  return (
    <AuthStateContext.Provider
      value={{
        state,
        useCurrencies,
        handleLogout,
      }}
    >
      <AuthDispatchContext.Provider value={dispatch}>
        {props.children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
}

function useAuthState() {
  const context = useContext(AuthStateContext);

  if (context === undefined) {
    throw new Error("useAuthState must be used within a AuthProvider");
  }

  return context;
}

function useAuthDispatch() {
  const context = useContext(AuthDispatchContext);

  if (context === undefined) {
    throw new Error("useAuthState must be used within a AuthProvide");
  }

  return context;
}

export { AuthProvider, useAuthDispatch, useAuthState };
